import React from 'react';
import { cn } from '@/lib/utils';
import snakeSignalsLogo from '@/assets/snake-signals-logo-clean.png';

interface BrandedLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  showSnakeSignals?: boolean;
  showPoweredBy?: boolean;
}

export const BrandedLogo: React.FC<BrandedLogoProps> = ({ 
  size = 'md', 
  className,
  showSnakeSignals = true,
  showPoweredBy = true
}) => {
  const logoSizes = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  const understandingLogoSizes = {
    sm: 'h-16',
    md: 'h-20',
    lg: 'h-24',
    xl: 'h-28'
  };

  const textSizes = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl'
  };

  const snakeSignalsTextSizes = {
    sm: 'text-base',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl'
  };

  return (
    <div className={cn("flex flex-col items-center gap-2", className)}>
      {/* Snake Signals Logo and Text */}
      {showSnakeSignals && (
        <div className="flex items-center gap-2 shrink-0">
          <img 
            src={snakeSignalsLogo}
            alt="Snake Signals Logo" 
            className={cn(
              "object-contain shrink-0",
              logoSizes[size]
            )}
          />
          <span className={cn(
            "font-bold font-orbitron text-primary tracking-wide whitespace-nowrap",
            snakeSignalsTextSizes[size]
          )}>
            Snake Signals
          </span>
        </div>
      )}
      
      {/* Powered by Understanding Recruitment */}
      {showPoweredBy && (
        <div className="flex items-center gap-3">
          <span className={cn("text-muted-foreground", textSizes[size])}>powered by</span>
          <a 
            href="https://www.understandingrecruitment.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity"
          >
            <img 
              src="/lovable-uploads/d9cd7f2e-a553-451e-a91c-2010e4d5866a.png"
              alt="Understanding Recruitment Group"
              className={cn("object-contain", understandingLogoSizes[size])}
            />
          </a>
        </div>
      )}
    </div>
  );
};
